import React from 'react'

const ContentMain = (props) => {
  return (
    <div id="content" role="main">
        {props.children}
    </div>
  )
}

export default ContentMain